module.exports = __webpack_public_path__ + "static/media/whyYouShould.214d71e5.png";